import { useQuery } from "react-query";
import { cacheKey } from "./shared";
import { getViewerAudioAdvertisements } from "frontend/src/api/user-tracks/get-for-viewer";
export var useViewerAdvertisements = function () {
    var _a = useQuery(cacheKey, getViewerAudioAdvertisements), data = _a.data, isLoading = _a.isLoading;
    return { data: data, isLoading: isLoading };
};
